import _ from "lodash";
import React from "react";
import moment from "moment";
import { DatePicker } from "../ui/DatePicker";

export const CheckboxList = ({ question, answers, otherValues, handlers }) => {
  const showOther = _.get(question, "questionType.showOther", false);
  const values = question.values || [];
  const otherValue = otherValues[question.id] || "";
  const otherChecked = !!otherValue && answers.includes(otherValue);

  return (
    <div className="form-component">
      {values.map((val, idx) => (
        <div key={idx} className="checkbox">
          <label>
            <input
              type="checkbox"
              checked={answers.includes(val)}
              onChange={() => handlers.handleCheckboxChange(question, val)}
            />
            {" " + val}
          </label>
        </div>
      ))}
      {showOther && (
        <div>
          <div className="checkbox">
            <label>
              <input
                type="checkbox"
                checked={otherChecked}
                onChange={() => handlers.handleOtherCheckboxChange(question)}
              />
              {" Other"}
            </label>
          </div>
          {otherChecked && (
            <input
              type="text"
              className="form-control"
              placeholder="Other (specify)"
              value={otherValue.trim()}
              onChange={(e) => handlers.handleOtherCheckboxInput(question, e.target.value)}
            />
          )}
        </div>
      )}
    </div>
  );
};

export const RadioList = ({ question, answers, otherValues, selectedOther, handlers }) => {
  const showOther = _.get(question, "questionType.showOther", false);
  const values = question.values || [];
  const selectedValue = answers[0] || "";
  const isOtherSelected = selectedOther[question.id] || false;
  const otherValue = otherValues[question.id] || "";

  return (
    <div className="form-component">
      {values.map((val, idx) => (
        <div key={idx} className="radio">
          <label>
            <input
              type="radio"
              name={`question_${question.id}`}
              value={val}
              checked={!isOtherSelected && selectedValue === val}
              onChange={() => handlers.handleRadioChange(question, val)}
            />
            {" " + val}
          </label>
        </div>
      ))}
      {showOther && (
        <div>
          <div className="radio">
            <label>
              <input
                type="radio"
                name={`question_${question.id}`}
                checked={isOtherSelected}
                onChange={() => handlers.handleOtherRadioSelect(question)}
              />
            </label>
          </div>
          <input
            type="text"
            className="form-control"
            placeholder="Other (specify)"
            disabled={!isOtherSelected}
            value={otherValue}
            onChange={(e) => handlers.handleOtherRadioInput(question, e.target.value)}
          />
        </div>
      )}
    </div>
  );
};

export const ValueRadioList = ({ question, answers, otherValues, selectedOther, handlers }) => {
  const showOther = _.get(question, "questionType.showOther", false);
  const values = question.values || [];
  const titles = question.titles || [];
  const selectedValue = answers[0] || "";
  const isOtherSelected = selectedOther[question.id] || false;
  const otherValue = otherValues[question.id] || "";

  return (
    <div className="form-component">
      {values.map((val, idx) => {
        const label = titles[idx] ? `${titles[idx]} (${val})` : val;
        return (
          <div key={idx} className="radio">
            <label>
              <input
                type="radio"
                name={`question_${question.id}`}
                value={val}
                checked={!isOtherSelected && selectedValue === val}
                onChange={() => handlers.handleRadioChange(question, val)}
              />
              {" " + label}
            </label>
          </div>
        );
      })}
      {showOther && (
        <div>
          <div className="radio">
            <label>
              <input
                type="radio"
                name={`question_${question.id}`}
                checked={isOtherSelected}
                onChange={() => handlers.handleOtherRadioSelect(question)}
              />
            </label>
          </div>
          <input
            type="text"
            className="form-control"
            placeholder="Other (specify)"
            disabled={!isOtherSelected}
            value={otherValue}
            onChange={(e) => handlers.handleOtherRadioInput(question, e.target.value)}
          />
        </div>
      )}
    </div>
  );
};

export const QuestionDatePicker = ({ question, answers, handlers }) => {
  const dateValue = answers[0]
    ? moment.isMoment(answers[0])
      ? answers[0]
      : moment(+answers[0])
    : null;

  return (
    <DatePicker
      className="mb-1"
      selected={dateValue?.isValid() ? dateValue : null}
      onChange={(date) => handlers.handleDateChange(question, date)}
      placeholderText="Select date"
    />
  );
};

export const ValueInput = ({ question, answers, handlers }) => (
  <input
    type="number"
    className="form-control mb-1"
    value={answers[0] || ""}
    onChange={(e) => handlers.handleValueChange(question, e.target.value)}
  />
);
